export const RESET_SESSION_TIMER = "RESET_SESSION_TIMER";

export const resetTimer = (expiryTime) => {
  if (!expiryTime) {
    return { type: RESET_SESSION_TIMER, payload: null };
  }

  return {
    type: RESET_SESSION_TIMER,
    payload: expiryTime,
  };
};
